import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api";

export const initialState = {
  poetas: [],
  error: null,
  loader: false,
  total: 0,
  is_more: false,
  current_page: 1,
  per_page: PAGELENGTH,
  last_page: 1
};

export const poetaSlice = createSlice({
  name: 'poetas',
  initialState,
  reducers: {
    setPoetas: (state, { payload }) => {
      state.poetas = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    }
  }
});

// --------------------------
// Thunks
// --------------------------

// Fetch all poetas
export const fetchPoetas = (page, params, disableLoader, Async) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchPoetas(page, params);
    if (result.status >= 200 && result.status < 300) {
      if (Async) {
        return result?.data?.data;
      } else {
        dispatch(setPoetas(result.data));
      }
    } else if (result?.status === 422) {
      if (Async) {
        return [];
      } else {
        dispatch(setError(result.data));
      }
    }
  } catch (error) {
    console.log("error", error);
  }
  !disableLoader && dispatch(setLoader(false));
};

// Add poeta
export const addPoeta = (data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addPoeta(data); // ensure this API method exists
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, json.data?.message || 'Something went wrong');
    }
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message || error.message || 'Request failed');
  }
  dispatch(setLoader(false));
};

// Update poeta
export const updatePoeta = (data, itemId, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.updatePoeta(data, itemId); // ensure this API method exists
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    } else {
      callback(false, json.data?.message || 'Something went wrong');
    }
  } catch (error) {
    console.log(error);
    callback(false, error.response?.data?.message || error.message || 'Request failed');
  }
  dispatch(setLoader(false));
};

// Remove multiple poetas
export const removeMultiplePoetas = (payload, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const res = await Api.removeMultiplePoetas(payload);
    if (res?.data?.success) {
      callback(true, res?.data?.message);
      dispatch(fetchPoetas());
    } else {
      callback(false, res?.data?.message || "Failed to delete");
    }
  } catch (err) {
    callback(false, "Something went wrong");
  } finally {
    dispatch(setLoader(false));
  }
};

// --------------------------
// Exports
// --------------------------
export const { setPoetas, setLoader, setError } = poetaSlice.actions;

export default poetaSlice.reducer;

// Selector
export const poetasSelector = (state) => state.poetas;
